<template>
  <div v-if="eligible" class="campaign-promotions">
    <div v-if="!floatingClosed" class="campaign-floating">
      <button
        class="floating-close"
        type="button"
        aria-label="关闭双十一悬浮图"
        @click="floatingClosed = true"
      >
        ×
      </button>
      <button
        class="floating-poster"
        type="button"
        aria-label="前往双十一活动页面"
        @click="goActivity"
      >
        <img
          src="@/assets/images/activity/rightPop.png"
          alt="双11钜惠，限时折扣"
        />
      </button>
    </div>
    <el-dialog
      :visible.sync="posterVisible"
      :append-to-body="true"
      :show-close="false"
      :z-index="20000"
      :close-on-click-modal="true"
      title="双十一限时充值加赠"
      width="88vw"
      top="10vh"
      custom-class="double-eleven-poster-dialog"
    >
      <button
        class="poster-close"
        type="button"
        aria-label="关闭活动弹窗"
        @click="dismissPoster"
      >
        ×
      </button>
      <button
        class="poster-image"
        type="button"
        aria-label="查看双十一充值套餐"
        @click="goActivity"
      >
        <img
          src="@/assets/images/post_1111.gif"
          alt="双十一限时囤图，点击查看本站充值加赠套餐"
        />
      </button>
      <p class="poster-bonus-note">本站双十一最高加赠 {{ maxBonusPercent }}%</p>
    </el-dialog>
  </div>
</template>

<script>
import {
  DOUBLE_ELEVEN,
  RECHARGE_PACKAGES,
  getCampaignPhase,
  hasMemberSession,
} from "@/utils/doubleEleven";
import { getToken, getTempUser } from "@/utils/storage";

export default {
  data() {
    return {
      now: Date.now(),
      timer: null,
      posterVisible: false,
      floatingClosed: false,
      campaignPath: DOUBLE_ELEVEN.path,
    };
  },
  computed: {
    maxBonusPercent() {
      return Math.max(
        ...RECHARGE_PACKAGES.map(
          ({ price, addprice }) => Math.round((addprice / price) * 1000) / 10
        )
      );
    },
    routePath() {
      return this.$route.path.replace(/\/+$/, "");
    },
    eligible() {
      if (!["upcoming", "active"].includes(getCampaignPhase(this.now)))
        return false;
      if (this.routePath === this.campaignPath) return true;
      return (
        hasMemberSession(getToken(), getTempUser()) &&
        !!this.routePath &&
        !/^\/(login|reset|registered|signOut|temporaryDownload|tempDown|freepik|qxDown|collect|401|404)(\/|$)/.test(
          this.routePath
        ) &&
        !this.$route.matched.some((record) => record.path === "*")
      );
    },
    posterTrigger() {
      if (!this.eligible || this.routePath === this.campaignPath) return "";
      // 路径或正式会话变化才重新弹出；查询条件、锚点和每秒计时不重复触发。
      return this.routePath + "|" + getToken();
    },
  },
  watch: {
    posterTrigger: {
      immediate: true,
      handler(trigger) {
        this.posterVisible = !!trigger;
      },
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
    this.$EventBus.$on("openDoubleElevenPoster", this.openPoster);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.$EventBus.$off("openDoubleElevenPoster", this.openPoster);
  },
  methods: {
    dismissPoster() {
      this.posterVisible = false;
    },
    openPoster() {
      this.now = Date.now();
      if (this.posterTrigger) this.posterVisible = true;
    },
    goActivity() {
      this.dismissPoster();
      if (this.routePath !== this.campaignPath) {
        this.$router.push({ path: this.campaignPath });
      } else {
        this.$nextTick(() => {
          const packages = document.getElementById("packages");
          if (packages)
            packages.scrollIntoView({ block: "start", behavior: "smooth" });
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-floating {
  position: fixed;
  right: 18px;
  top: 48%;
  z-index: 10001;
  width: 118px;
}
.floating-poster {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}
.floating-poster img {
  display: block;
  width: 100%;
  height: auto;
}
.floating-close {
  position: absolute;
  right: -2px;
  top: -5px;
  width: 21px;
  height: 21px;
  padding: 0;
  border: 1px solid #f3a175;
  border-radius: 50%;
  color: #fff;
  background: #c83226;
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;
}
@media (max-width: 760px) {
  .campaign-floating {
    top: auto;
    bottom: 20px;
    right: 10px;
    width: 76px;
  }
}
</style>

<style lang="scss">
.el-dialog.double-eleven-poster-dialog {
  width: 88vw !important;
  margin-top: 10vh !important;
  max-width: 430px;
  max-height: 82vh;
  background: transparent !important;
  box-shadow: none;
  .el-dialog__header {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
  }
  .el-dialog__body {
    padding: 0;
  }
  .poster-image {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  .poster-image img {
    display: block;
    width: 100%;
    height: auto;
    max-height: calc(78vh - 48px);
    object-fit: contain;
  }
  .poster-bonus-note {
    box-sizing: border-box;
    width: fit-content;
    max-width: 100%;
    margin: 8px auto 0;
    padding: 7px 16px;
    border: 1px solid #f5c56b;
    border-radius: 24px;
    background: #b92b22;
    color: #ffe6a8;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
  }
  .poster-close {
    position: absolute;
    right: 0;
    top: -15px;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    background: #9d251f;
    font-size: 25px;
    line-height: 28px;
    cursor: pointer;
    z-index: 1;
  }
}
</style>
